import { render, staticRenderFns } from "./ActionPostbackText.vue?vue&type=template&id=0a9f941c&"
import script from "./ActionPostbackText.vue?vue&type=script&lang=js&"
export * from "./ActionPostbackText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports